import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { discardSearchResultsOptions } from '../actions/internalActions';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import {
    getIsBitSet as getIsSearchBitSet,
    SearchBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/searchBitFlagsUtil';

mutator(discardSearchResultsOptions, () => {
    getStore().excludeDeletedItemsInSearch = getIsBitSet(
        ListViewBitFlagsMasks.ExcludeDeletedItemsInSearch
    );

    getStore().scopeToInboxFolder = getIsSearchBitSet(SearchBitFlagsMasks.ScopeInboxSearchToFolder);
});
